<template>
    <div ref="videoWrapper" @mouseenter="onMouseEnter" @mousemove="onMouseEnter" @mouseleave="onMouseLeave" @touchend="onTap" class="gallery-video" :class="{'gallery-modal__carousel-item' : (mode === 'full') }">
        <picture v-if="mode === 'full'" data-type="full">
            <source media="(min-width: 1440px)" :data-srcset-observer="`${item.image}?width=1200`" />
            <source media="(min-width: 1200px) and (max-width: 1439px)" :data-srcset-observer="`${item.image}?width=1100`" />
            <source media="(min-width: 992px) and (max-width: 1219px)" :data-srcset-observer="`${item.image}?width=1000`" />
            <source media="(min-width: 768px) and (max-width: 991px)" :data-srcset-observer="`${item.image}?width=850`" />
            <source media="(max-width: 768px)" :data-srcset-observer="`${item.image}?width=600`" />
            <img class="asset-img" v-show="(isPlaying === false && isFullscreen == false && mode !== 'full')" :data-src-observer="`${thumbnailPauseImage}?width=700`" :fetchpriority="isPriority ? 'high' : 'low'" @click="videoPlay" :width="item.imageWidth" :height="item.imageHeight" :alt="item.imageAlternativeText" :aria-label="item.imageAlternativeText" />
        </picture>
        <picture v-else data-type="list">
            <source media="(min-width: 1800px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 1800')}`" />
            <source media="(min-width: 1440px) and (max-width: 1799px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 1440 && < 1799')}`" />
            <source media="(min-width: 1200px) and (max-width: 1439px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 1200 && < 1439')}`" />
            <source media="(min-width: 992px) and (max-width: 1199px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 992 && < 1199')}`" />
            <source media="(min-width: 768px) and (max-width: 991px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 768px && < 991')}`" />
            <source media="(min-width: 540px) and (max-width: 767px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('> 540 && < 767 x1')} 1x, ${item.image}?width=${getImageSrcSetSize('> 540 && < 767 x2')} 2x`" />
            <source media="(max-width: 539px)" :data-srcset-observer="`${item.image}?width=${getImageSrcSetSize('< 539 x1')} 1x, ${item.image}?width=${getImageSrcSetSize('< 539 x2')} 2x`" />
            <img class="asset-img" :fetchpriority="isPriority ? 'high' : 'low'" :loading="isPlaying == false ? 'lazy' : ''" v-show="(isPlaying === false && isFullscreen == false && mode !== 'full')" :data-src-observer="`${item.image}?width=600`" @click="videoPlay" :width="item.imageWidth" :height="item.imageHeight" :alt="item.imageAlternativeText" :aria-label="item.imageAlternativeText" />
        </picture>

        <video :width="isOldiOS === false? item.imageWidth : false" :height="isOldiOS === false ? item.imageHeight : false" @click="videoToggle" v-show="isPlaying || isFullscreen || (isPlaying == false && mode === 'full')" allowfullscreen="true" controllist="none" playsinline disableremoteplayback disablePictureInPicture="true" x-webkit-airplay="deny" preload="auto" :data-poster="isPriority == false ? posterUrl : null" :loop="loopAttribute" :muted="mutedAttribute" :aria-label="item.imageAlternativeText" :autoplay="autoplayAttribute" ref="videoElem" class="asset-vid" :class="{'focus-visible': galleryVersion == 'legacy'}">
            <template v-if="mode === 'full'">
                <source v-if="item.fullVideoMp4" type="video/mp4" :data-src-observer="item.fullVideoMp4">
                <source v-if="item.fullVideoWebM" type="video/webm" :data-src-observer="item.fullVideoWebM">
            </template>
            <template v-else-if="mode === 'thumbnail'">
                <source v-if="item.thumbnailVideoMp4" type="video/mp4" :src="item.thumbnailVideoMp4">
                <source v-if="item.thumbnailVideoWebM" type="video/webm" :src="item.thumbnailVideoWebM">
            </template>
        </video>

        <transition name="fade">
            <div class="video-controls" :class="{ 'show' : ((mouseHovered || isParentFocused || hasControlFocus || showVideoControls) && isPlaying == false)}">
                <button @click.stop="videoToggle" class="btnVideoPlayPause" :class="{'focus-visible': galleryVersion == 'legacy'}" :aria-label="isPlaying ? labels.videoPauseLabel : labels.videoPlayLabel " type="button" :tabindex="(mouseHovered || isParentFocused || hasControlFocus || showVideoControls ) ? '0': false" @focus="onFocus" @blur="onBlur">
                    <span :aria-hidden="isPlaying" v-show="isPlaying === false" class="btnVideoPlay"></span>
                    <span :aria-hidden="isPlaying === false" v-show="isPlaying === true" class="btnVideoPause"></span>
                </button>
            </div>
        </transition>

        <transition name="fade">
            <template v-if="mode === 'full'">
                <div class="gallery__videoControls-wrapper">
                    <div class="gallery__videoControls" :class="{ 'show': ((mouseHovered || isParentFocused || hasControlFocus) && isPlaying) }">
                        <button :class="isPlaying ? 'gallery__videoControls-pause' : 'gallery__videoControls-play'" @click="videoToggle" tabindex="0" :aria-label="isPlaying ? labels.videoPauseLabel : labels.videoPlayLabel"></button>
                        <div ref="videoProgressBar" role="slider" :aria-label="labels.videoProgressBarLabel" aria-valuemin="0" :aria-valuemax="videoDuration" :aria-valuenow="videoCurrent" :aria-valuetext="videoHumanAriaStr" class="gallery__videoControls-progressBar" @mousedown="progressBarClickDown" @mousemove="mouseMove" @touchmove="touchMoveHandler">
                            <div class="gallery__videoControls-progressBar-track"></div>
                            
                            <div class="gallery__videoControls-progressBar-head-positioner" v-bind:style="progressBarHeadPosition">
                                <div ref="videoProgressBarHead" class="gallery__videoControls-progressBar-head" :aria-label="labels.videoProgressBarHeadLabel"></div>
                            </div>
                        </div>
                        <button class="gallery__videoControls-fullscreen" @click="toggleFullscreen" :aria-label="labels.videoFullScreenLabel"></button>
                        <button class="gallery__videoControls-mute" v-show="hasAudio" :aria-hidden="hasAudio == false" v-bind:class="isMuted ? 'unmute' : 'mute'" @click="isMuted ? videoUnmute() : videoMute()" :aria-label="isMuted ? labels.videoUnmuteLabel : labels.videoMuteLabel"></button>
                    </div>
                </div>
            </template>
        </transition>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { getImageSrcSetSizeBasedOnGallery, durationTextFormatter, checkVersion } from '../mixins/helpers';
    import { bus } from '../_event-bus';

    let durationFormatter = typeof durationTextFormatter === 'function' ? durationTextFormatter(window.preferredCulture ?? 'en') : null;

    const PROMO_BLOCK_WRAPPER = '.gallery .video__wrapper';
    const VIDEO_CONTROLS_PROGRESS_BAR_CLASS = '.gallery__videoControls-progressBar';
    const VIDEO_CONTROLS_PROGRESS_HEAD_CLASS = '.gallery__videoControls-progressBar-head';

    export default {
        name: 'GalleryVideo',
        props: ['mode', 'item', 'is-parent-focused', 'is-priority'],
        data() {
            return {
                isPlaying: null,
                isMuted: false,
                initialLoad: true,
                mouseHovered: false,
                hasControlFocus: false,
                hasControls: false,
                isFullscreen: false,
                isFirstPlay: true,
                videoPlaybackPercentage: -1,
                isMouseEntered: false,
                isMouseExit: false,
                isMouseMoving: false,
                mouseMoveTimer: null,
                isVideoScrubbing: false,
                progressBarBoundingBox: null,
                progressBarHeadHalfWidth: null,
                hasAudio: false,
                videoObserver: null,
                videoDurationSeconds: null,
                videoCurrentSeconds: null,
                tapTimer: null,
            }
        },

        computed: {
            ...mapState('gallery', [
                'autoplay',
                'galleryVersion',
            ]),

            ...mapState('translations', [
                'labels',
            ]),

            loopAttribute() {
                return this.mode === 'thumbnail' || (this.mode === 'full' && this.item.loop);
            },

            mutedAttribute() {
                return this.mode === 'thumbnail' || (this.mode === 'full' && this.item.mute);
            },
            
            autoplayAttribute() {
                return (this.mode === 'thumbnail' && this.autoplay === true) || (this.mode === 'full' && this.item.autoplay)
            },

            thumbnailPauseImage() {
                if (this.galleryVersion === 'modern') return this.item.thumbnailImage; 
                else return this.item.image;
            },

            showVideoControls() {
                return (this.mode === 'full' && this.isPlaying === false);
            },  
            
            progressBarHeadPosition() {
                return {
                    translate: this.videoPlaybackPercentage < 0 ? '0% 0%' : `${this.videoPlaybackPercentage}% 0%`
                }
            },

            posterUrl() {
                // We cannot resize the poster when in the modal as that will physically render a smaller asset, so we reduce the quality a bit so it is faster to load
                if (this.mode === 'full') {
                    return `${this.item.image}?quality=80`
                } else {
                    return `${this.item.image}?width=600`;
                }
            },

            videoDuration() {
                if (this.videoDurationSeconds != null) {
                    return this.videoDurationSeconds;
                } else {
                    return "Unknown";
                }
            },

            videoCurrent() {
                if (this.videoCurrentSeconds != null) {
                    return this.videoCurrentSeconds;
                } else {
                    return "Unknown";
                }
            },

            videoHumanAriaStr() {
                if (durationFormatter == null) return;
                
                if (this.videoCurrentSeconds == null|| this.videoDurationSeconds == null) return 'Unknown';
                const currentTimeStr = durationFormatter(this.videoCurrentSeconds * 1000);
                const durationTimeStr = durationFormatter(this.videoDurationSeconds * 1000);
                const videoPrepositionText = this.labels.videoSeekAriaValuePreposition ? this.labels.videoSeekAriaValuePreposition : 'of';
                const output = `${currentTimeStr} ${videoPrepositionText} ${durationTimeStr}`.trim();

                return output.replaceAll(/\s/g, ' ');  // Due to a bug in prop handling for VueJS you have to encode to avoid rendering as &nbsp;
            },

            isOldiOS() {
                return checkVersion() && checkVersion().version <= 14.8 ? true : false;
            }
        },
        created() {
            const that = this;

            this.isPlaying = this.autoplayAttribute;
            this.isMuted = this.mutedAttribute;

            bus.$on('ListingItemsChanged', () => {
                this.$nextTick(() => {
                    this.checkVisibilityToAutoplayVideo();
                });
            });

            bus.$on('PageVisibleAgain', () => {
                // When the page becomes visible again, we should play any videos that are autoplay
                if(this.mode === 'thumbnail' && this.autoplay === true) {
                    this.isPlaying = true;
                    this.videoPlay();
                }
                else if (this.mode === 'full') {
                    // Check if video was playing, if it was we should check the current status now that the tab is active                
                    setTimeout(() => {
                        this.isPlaying = !this.$refs.videoElem?.paused;
                    }, 250); // This delay is to allow the browser to catchup and replay the video itself
                }
            });
        },
        mounted() {
            // This has been uncommented to allow videos to autoplay naturally, I'm surprised that asking it to play is what caused it to not play.
            // if (this.autoplayAttribute) {
            //     this.$nextTick(() => {
            //         this.videoPlay();
            //     });
            // }

            this.$refs.videoElem.addEventListener('playing', this.setVideoFirstRun);
            this.$refs.videoElem.addEventListener('pause', this.manualVideoPause);
            this.$refs.videoElem.addEventListener('loadeddata', this.onVideoLoadedData);

            this.$refs.videoElem.disablePictureInPicture = true;

            this.setupIntersectionObserver();

            if (this.mode === 'full') {
                if (this.autoplayAttribute == false) {
                    this.videoPause();
                }
                this.$refs.videoElem.addEventListener('carouselSlideChange', this.handleCarouselSlideChange);
                this.$refs.videoElem.addEventListener('timeupdate', this.progressBarUpdateTicker);
                this.$refs.videoElem.addEventListener('ended', this.videoReset);
                this.$refs.videoElem.addEventListener('fullscreenchange', this.onFullscreenChange);

                document.addEventListener('mouseup', this.mouseUp);

                this.$nextTick(() => {
                    if (this.$refs.videoProgressBar && this.$refs.videoProgressBarHead) {
                        this.progressBarBoundingBox = this.$refs.videoProgressBar.getBoundingClientRect();
                        this.progressBarHeadHalfWidth = this.$refs.videoProgressBarHead.getBoundingClientRect().width / 2;
                    }
                });

                document.addEventListener("fullscreenchange", this.onFullscreenChange);

                this.$refs.videoElem.addEventListener('webkitendfullscreen', () => {
                    document.querySelector('html').classList.remove('video-fullscreened');
                    document.querySelector('html').classList.add('video-fullscreened-exited');
                    this.isFullscreen = false;
                    this.$refs.videoElem.removeAttribute('controls', 'controls');
                    this.isPlaying = this.$refs.videoElem.paused === false;  // iOS seems to always pause video after it closes
                });

                // This event doesnt seem to fire
                this.$refs.videoElem.addEventListener('webkitenterfullscreen', () => {
                    document.querySelector('html').classList.add('video-fullscreened');
                    document.querySelector('html').classList.remove('video-fullscreened-exited');
                    this.isFullscreen = true;
                });

                const event = new CustomEvent('VideoVueComponentMounted');
                document.dispatchEvent(event);
            }
        },

        beforeDestroy() {
            this.$refs.videoElem.removeEventListener('playing', this.setVideoFirstRun);
            this.$refs.videoElem.removeEventListener('pause', this.manualVideoPause);
            this.$refs.videoElem.removeEventListener('carouselSlideChange', this.handleCarouselSlideChange);
            this.$refs.videoElem.removeEventListener('loadeddata', this.onVideoLoadedData);
            this.$refs.videoElem.removeEventListener('timeupdate', this.progressBarUpdateTicker);
            this.$refs.videoElem.removeEventListener('ended', this.videoReset);
            this.$refs.videoElem.removeEventListener('fullscreenchange', this.onFullscreenChange);
            document.removeEventListener('fullscreenchange', this.onFullscreenChange);

            document.removeEventListener('mouseup', this.mouseUp);

            if (this.videoObserver) {
                this.videoObserver.disconnect();
            }
        },

        methods: {
            checkVersion() {
                return checkVersion();
            },
            onFocus() {
                this.hasControlFocus = true;
            },
            onBlur() {
                setTimeout(() => {
                    this.hasControlFocus = false;
                }, 50);
            },

            onTap() {
                this.mouseHovered = true;
                this.setControlsHideTimers();
            },
            onMouseEnter() {
                if (window.innerWidth < 768) return;

                this.mouseHovered = true;
                this.setControlsHideTimers();
            },
            onMouseLeave() {
                if (window.innerWidth < 768) return;

                this.mouseHovered = false;
            },
            setControlsHideTimers() {
                const self = this;

                if (this.mouseMoveTimer) { clearTimeout(this.mouseMoveTimer); }
                if (this.tapTimer) { clearTimeout(this.tapTimer); }

                this.mouseMoveTimer = setTimeout(function () {
                    self.isMouseMoving = false;
                    self.mouseHovered = false;
                }, 1500);

                this.tapTimer = setTimeout(function () {
                    self.isMouseMoving = false;
                    self.mouseHovered = false;
                }, 1500);
            },
            setVideoFirstRun() {
                this.initialLoad = false;
            },
            videoPause() {
                this.$refs.videoElem.pause();
                this.isPlaying = false;

                // Only reset the progres to 0 when we are not in the modal
                if (this.mode !== "full") {
                    this.$refs.videoElem.currentTime = 0;
                }
            },

            videoPlay() {
                this.$refs.videoElem.play().then(() => {
                    setTimeout(() => {
                        this.isPlaying = true;
                    }, 5);
                }).catch(e => {
                    // Error pausing, so assume video is playing?
                    this.isPlaying = false;
                });
            },

            videoToggle() {
                if (this.isPlaying) {
                    this.videoPause();
                } else {
                    this.videoPlay();
                }
            },

            videoMute() {
                this.isMuted = true;
                this.$refs.videoElem.muted = true;
            },

            videoUnmute() {
                this.isMuted = false;
                this.$refs.videoElem.muted = false;
            },

            handleCarouselSlideChange(customEvent) {
                if (customEvent.detail.state === 'old-slide') {
                    this.videoPause();
                } else if (customEvent.detail.state === 'new-slide' && this.autoplayAttribute) {
                    this.videoPlay();
                }
            },

            manualVideoPause() {
                this.isPlaying = false;
            },

            videoReset() {
                // We only want to reset if the video does not automatically loop. This sets the video at the start so the user can restart video using controls.
                if (this.isLooping === false) {
                    this.isPlaying = false;
                    this.videoPlaybackPercentage = 0;
                    this.$refs.videoElem.currentTime = 0;
                    this.videoCurrentSeconds = 0;
                }
            },

            touchEndEvent: function (e) {
                this.isVideoScrubbing = false;
            },

            touchMoveHandler: function (e) {
                e.stopPropagation()
                const touchHandler = e.changedTouches[0]
                this.isVideoScrubbing = true;
                this.mouseMove(e, touchHandler);
            },

            getVideoPercentage() {
                return (this.$refs.videoElem.currentTime / this.$refs.videoElem.duration) * 100;
            },

            mouseUp() {
                this.isVideoScrubbing = false;
            },

            mouseEntered() {
                this.isMouseEntered = true;
                this.isMouseExit = false;
            },

            mouseExit() {
                this.isMouseEntered = false;
                this.isMouseExit = true;
            },

            mouseMove(event, isDraggingEvent) {
                const self = this;

                event.stopPropagation();
                this.isMouseMoving = true;

                if (this.isVideoScrubbing) {
                    this.progressBarClickMove(event, isDraggingEvent);
                    this.progressBarUpdateTicker();
                }

                if (this.mouseMoveTimer) {
                    clearTimeout(this.mouseMoveTimer);
                }

                if (this.tapTimer) {
                    clearTimeout(this.tapTimer);
                }                
            },

            toggleFullscreen() {
                var cancelFullScreen =
                    document.exitFullscreen ||
                    document.webkitExitFullscreen ||
                    document.mozCancelFullScreen ||
                    document.msExitFullscreen ||
                    this.$refs.videoElem.webkitExitFullscreen;

                var isInFullScreen = this.isVideoInFullscreen();

                if (!isInFullScreen) {

                    if (document.documentElement.requestFullscreen) {
                        try {
                            this.$refs.videoElem.requestFullscreen();
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.mozRequestFullScreen) {
                        try {
                            this.$refs.videoElem.mozRequestFullScreen(); // Firefox
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.webkitRequestFullscreen) {

                        try {
                            this.$refs.videoElem.webkitRequestFullscreen(); // Chrome and Safari
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.msRequestFullscreen) {
                        try {
                            this.$refs.videoElem.msRequestFullscreen(); // IE
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (this.$refs.videoElem.webkitEnterFullscreen) {
                        try {
                            this.$refs.videoElem.webkitEnterFullscreen();
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        console.error("Cannot find video fullscreen support");
                    }
                    this.$refs.videoElem.setAttribute('controls', 'controls');
                    document.querySelector('html').classList.add('video-fullscreened');
                    document.querySelector('html').classList.remove('video-fullscreened-exited');
                    if (document.body.clientWidth < 997) {
                        screen.orientation.lock(screen.orientation.type)
                    }

                } else {
                    cancelFullScreen().then(function () {
                        this.isFullscreen = false;
                        // Detect if video was fullscreen in iOS if so we need to state video is not playing as it always closes fullscreen and pauses video
                      
                    }).catch(function (err) {
                        // self.state.fullScreen = true;
                        console.error("Issue hiding video in fullscreen", err.message);
                    });
                }
            },

            onFullscreenChange(event) {
                var isInFullScreen = this.isVideoInFullscreen();

                if (!isInFullScreen) {
                    this.videoPause();
                    this.isFullscreen = false;
                    this.$refs.videoElem.removeAttribute('controls');

                    // 150767 - This technique is used to force a repaint of the video element as it was not painting correctly in Safari after existing fullscreen
                    setTimeout(() => {
                        this.$refs.videoElem.style.display = 'none';
                        var height =  this.$refs.videoElem.offsetHeight;
                        this.$refs.videoElem.style.display = 'block';
                    });
                }
            },

            isVideoInFullscreen() {
                return (document.fullscreenElement && document.fullscreenElement !== null) ||
                        (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
                        (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
                        (document.msFullscreenElement && document.msFullscreenElement !== null) ||
                        this.$refs.videoElem.webkitDisplayingFullscreen;
            },
            progressBarClickDown(event) {
                event.stopPropagation();
                this.isVideoScrubbing = true;
                this.progressBarClickMove(event);
            },

            progressBarClickUp(event) {
                event.stopPropagation();
                this.isVideoScrubbing = false;
            },

            progressBarClickMove(event, isDraggingEvent) {
                if (!this.isVideoScrubbing) return;
                event.stopPropagation();

                // If we are dragging the scrub bar we want to ensure we clear the video contaoner mouse out timer so it doesnt hide the controls prematurely.
                if (this.mouseMoveTimer) {
                    clearTimeout(this.mouseMoveTimer);
                }

                this.progressBarBoundingBox = this.$refs.videoProgressBar.getBoundingClientRect();
                // Calculate the offset percetnage in the bar where the users click was performed

                const trackClickPercentage = parseFloat(((isDraggingEvent ? (isDraggingEvent.clientX - this.progressBarBoundingBox.left - this.progressBarHeadHalfWidth) : event.clientX - this.progressBarBoundingBox.left - this.progressBarHeadHalfWidth) / this.progressBarBoundingBox.width).toFixed(3));
                
                this.progressBarSetTime(trackClickPercentage);
            },

            progressBarSetTime(percentage) {
                if (isNaN(this.$refs.videoElem.duration) || percentage < 0) return; // If the video hasnt loaded then we cannot scrub through it.
                this.$refs.videoElem.currentTime = (percentage * this.$refs.videoElem.duration).toFixed(3);
            },

            progressBarUpdateTicker() {
                // Only timeupdated is reliable event so we are using this to detect when the video has first started playing
                if (this.isFirstPlay) {
                    this.isFirstPlay = false;
                }
                this.videoPlaybackPercentage = this.getVideoPercentage();
                this.videoCurrentSeconds = Math.floor(this.$refs.videoElem.currentTime);
            },

            onVideoLoadedData() {
                this.checkIfVideoHasAudio();

                this.videoDurationSeconds = Math.floor(this.$refs.videoElem?.duration);
                this.videoCurrentSeconds = Math.floor(this.$refs.videoElem?.currentTime);
            },

            checkIfVideoHasAudio() {
                if (typeof this.$refs.videoElem.webkitAudioDecodedByteCount !== "undefined") {
                    if (this.$refs.videoElem.webkitAudioDecodedByteCount > 0) {
                        this.hasAudio = true;
                    } else {
                        this.hasAudio = false;
                    }
                }
                else if (typeof this.$refs.videoElem.mozHasAudio !== "undefined") {
                    if (this.$refs.videoElem.mozHasAudio) {
                        this.hasAudio = true;
                    } else {
                        this.hasAudio = false;
                    }
                }
                else {
                    // Cant tell if the vide has audio so assume it does not
                    this.hasAudio = false;
                }
            },

            getImageSrcSetSize(viewportRule) {
                return getImageSrcSetSizeBasedOnGallery(viewportRule, this.galleryVersion);
            },
            checkVisibilityToAutoplayVideo() {
                if (this.item.visible == false) return;

                if (this.mode === 'thumbnail' && this.autoplay === true) {
                    this.videoPlay();
                }
            },

            setupIntersectionObserver() {
                // This is used so we can detect the element is back into view, if so we should play the video when if its autoplay
                const observerOptions = {
                    threshold: [0, 0.45],
                    rootMargin: '50px 0px 50px 0px' // These values allow area space for the element to first be lazyloaded, this allows it to start when its "Out of the viewport"
                };

                this.videoObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) {
                            return;
                        }

                        if (this.mode !== 'thumbnail' || this.autoplay !== true) return; // Only observe lising videos when autoplay is true
                        this.isPlaying = true;
                        this.videoPlay();
                    });
                }, observerOptions);

                this.videoObserver.observe(this.$refs.videoWrapper);
            },
        },
        watch: {
            autoplay(newValue) {
                if (newValue == false && this.isPlaying == true) {
                    this.videoPause();
                }

                if (newValue == true && this.isPlaying == false) {
                    this.videoPlay();
                }
            }
        }
    }
</script>